const DeepModel = require('./backbone-deep-model');

module.exports = DeepModel.extend({
    _startDirtyTracking : function() {
        this.on('sync', function() {
            this.revertAttributes = this.attributes;
            this.isDirty = false;
        });
        this.on('change', function() {
            this.isDirty = true;
        });
        this.revert = function() {
            this.set(this.revertAttributes);
            this.isDirty = false;
        };
    }
});